export function SignInStatusDot({ online }: { online: boolean }) {
  if (online) {
    return (
      <span className="relative flex h-4 w-4 items-center justify-center">
        <span className="absolute inline-flex h-full w-full rounded-full bg-primary opacity-75 animate-ping [animation-duration:2.5s]"></span>
        <span className="relative inline-flex h-3 w-3 rounded-full border-2 border-background bg-primary shadow"></span>
      </span>
    );
  }
  return (
    <span className="relative flex h-4 w-4 items-center justify-center">
      <span className="relative inline-flex h-3 w-3 rounded-full border-2 border-background bg-steel shadow"></span>
    </span>
  );
}
